__webpack_require__.p = "/assets/turbo/9d0eb0b4/ottonl/_next/";